import { RouterManager } from '@aclass/admin/managers';
import { AdditionalProductStory } from '@aclass/admin/storage/actions';
import { IAdditionalProductModuleState, IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class AdditionalProductSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:additional-product-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IAdditionalProductModuleState['searchPageInitialized']>(['additionalProductModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(AdditionalProductSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(AdditionalProductStory.dryRunSearchPage());
    }
}
